






















































































































import Button from '@/app/ui/components/Button/index.vue'
import { AssignPickupBulkHistoryItem } from '@/domain/entities/Pickup'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import IconWhatsApp from '@/app/ui/assets/ics_f_whatsapp.vue'
import Badge from '@/app/ui/components/Badge/index.vue'
import CloseLine from '@/app/ui/assets/close_line.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import PickupController from '@/app/ui/controllers/PickupController'

@Component({
  components: {
    Button,
    IconWhatsApp,
    Badge,
    CloseLine,
    EyeIcon,
    EyeDisabledIcon
  },
})
export default class AssignPickupBulkHistoryModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({ type: Array, default: [] }) readonly assignPickupBulkHistoryData!: AssignPickupBulkHistoryItem[]

  controller = PickupController
  revealed: Set<string> = new Set()

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  public waSenderHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menghubungi terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  @Watch('visible')
  onVisibleChange(): void {
    if (this.visible) {
      this.revealed = new Set()
    }
  }

  isRevealed(id: string, field: string): boolean {
    return this.revealed.has(`${id}-${field}`)
  }

  findItem(id: string): AssignPickupBulkHistoryItem | undefined {
    return this.assignPickupBulkHistoryData.find(p => p.shipperHash === id)
  }

  async showField(id: string, field: string, apiField: string): Promise<void> {
    if (!id) return
    const item = this.findItem(id)
    if (!item) return
    try {
      const resp = await this.controller.adminContactShow({
        resource: 'shipper_hash',
        resourceId: id,
        field: apiField,
        source: 'pickup_crrnfdv2_on_process'
      })
      if (field === 'phone') {
        item.phoneNumber = resp.value || '-'
      }
      this.revealed.add(`${id}-${field}`)
      this.revealed = new Set(this.revealed)
    } catch {
      /* ignore */
    }
  }

  hideField(id: string, field: string): void {
    this.revealed.delete(`${id}-${field}`)
    this.revealed = new Set(this.revealed)
  }

  decideClass(status: string):string {
    if(status === 'waiting') {
      return 'warning'
    }
    if(status === 'success') {
      return 'success'
    }
    return 'error'
  }

  decideTitle(status: string):string {
    if(status === 'waiting') {
      return 'Dalam Proses'
    }
    if(status === 'success') {
      return 'Berhasil'
    }
    return 'Gagal'
  }

  public onClose(): void {
    const successShipperHash = this.assignPickupBulkHistoryData.filter((item) => item.status === "success" || item.status === "failed").map((item) => item.shipperHash)
    this.$emit('close', successShipperHash)
  }
}
